import React, { useState } from "react";
import "../styles/partnershipEnquiry.css";

const PartnershipEnquiry = () => {
  const [formData, setFormData] = useState({
    title: "",
    fullName: "",
    email: "",
    phone: "",
    organization: "",
    country: "",
    interest: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    console.log(formData);

    alert("Thank you! Your partnership enquiry has been submitted.");
  };

  return (
    <div className="enquiry-page">

      <section className="enquiry-hero">
        <div className="hero-badge">Partnership Opportunities</div>

        <h1>
          Complete the <span>Partnership Enquiry Form</span>
        </h1>

        <p>
          We welcome collaboration opportunities from institutions,
          researchers, corporations, funding agencies, media partners,
          and advisors who share our vision for sustainable development.
        </p>
      </section>

      <section className="form-section">
        <div className="form-card">

          <form onSubmit={handleSubmit}>

            <div className="grid-2">

              <div className="form-group">
                <label>Title</label>
                <select
                  name="title"
                  value={formData.title}
                  onChange={handleChange}
                >
                  <option value="">Select</option>
                  <option>Mr.</option>
                  <option>Mrs.</option>
                  <option>Ms.</option>
                  <option>Dr.</option>
                  <option>Prof.</option>
                </select>
              </div>

              <div className="form-group">
                <label>Full Name</label>
                <input
                  type="text"
                  name="fullName"
                  placeholder="Enter Your Full Name"
                  value={formData.fullName}
                  onChange={handleChange}
                />
              </div>

              <div className="form-group">
                <label>Email</label>
                <input
                  type="email"
                  name="email"
                  placeholder="Email Address"
                  value={formData.email}
                  onChange={handleChange}
                />
              </div>

              <div className="form-group">
                <label>Phone Number</label>
                <input
                  type="text"
                  name="phone"
                  placeholder="Phone Number"
                  value={formData.phone}
                  onChange={handleChange}
                />
              </div>

              <div className="form-group">
                <label>Organization / Institution</label>
                <input
                  type="text"
                  name="organization"
                  placeholder="Organization / Institution"
                  value={formData.organization}
                  onChange={handleChange}
                />
              </div>

              <div className="form-group">
                <label>Country</label>
                <input
                  type="text"
                  name="country"
                  placeholder="Select Country"
                  value={formData.country}
                  onChange={handleChange}
                />
              </div>

              <div className="form-group full-width">
                <label>Partnership Interest</label>

                <select
                  name="interest"
                  value={formData.interest}
                  onChange={handleChange}
                >
                  <option value="">Please Select</option>
                  <option>Funding Partner</option>
                  <option>Technical Research Collaboration</option>
                  <option>Implementation Partner</option>
                  <option>Corporate / CSR Partner</option>
                  <option>Media Knowledge / Publications</option>
                  <option>Voluntary Advisor</option>
                </select>
              </div>

              <div className="form-group full-width">
                <label>Brief Message</label>

                <textarea
                  rows="6"
                  name="message"
                  placeholder="Type Your Brief Message Here"
                  value={formData.message}
                  onChange={handleChange}
                />
              </div>

            </div>

            <div className="contact-note">
              <strong>Prefer email or have a detailed proposal?</strong>
              <br />
              You may also reach us at
              <a href="mailto:rakeshsamala0505@gmail.com">
                {" "}
                maharishi.iimr@gmail.com
              </a>
            </div>

            <button type="submit" className="submit-btn">
              Submit Enquiry
            </button>

          </form>
        </div>
      </section>

    </div>
  );
};

export default PartnershipEnquiry;